import { render, staticRenderFns } from "./QuestionsAnswersForm.vue?vue&type=template&id=07c24971&scoped=true&"
import script from "./QuestionsAnswersForm.vue?vue&type=script&lang=js&"
export * from "./QuestionsAnswersForm.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsAnswersForm.vue?vue&type=style&index=0&id=07c24971&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c24971",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VFlex,VForm})
